import React from 'react';
import {Checkbox} from '@/components/atoms';
import {withJsonFormsControlProps} from '@jsonforms/react';
import PropTypes from 'prop-types';

const CheckboxComponent = (props) => {
  /**
   * CheckboxControl component props.
   *
   * @typedef {Object} Props
   * @property {function} handleChange - Function to handle change events.
   * @property {string} label - Label for the checkbox.
   * @property {Object} data - Data associated with the checkbox.
   * @property {string} path - Path to the data.
   * @property {Object} errors - Errors related to the checkbox.
   * @property {Object} schema - Schema for the checkbox data.
   * @property {Object} uischema - UI schema for the checkbox.
   * @property {boolean} enabled - Flag to indicate if the checkbox is enabled.
   * @property {boolean} required - Flag to indicate if the checkbox is required.
   */
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    enabled,
    required
  } = props;
  return (
    <Checkbox
      value={data}
      label={label}
      updateValue={(newVal) => handleChange(path, newVal)}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      disabled={!enabled}
    />
  );
};

CheckboxComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.any,
  path: PropTypes.string.isRequired,
  errors: PropTypes.object,
  schema: PropTypes.object.isRequired,
  uischema: PropTypes.object,
  enabled: PropTypes.bool,
  required: PropTypes.bool
};

const CheckboxControl = withJsonFormsControlProps(CheckboxComponent);
export default React.memo(CheckboxControl);
